var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages"},_vm._l((_vm.allMessages),function({ type, text, persist },id){return _c('Message',{key:id,attrs:{"type":type,"text":text,"persist":persist}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }